/*import { useState } from "react";

const BODY_REGIONS = {
  front: [
    { id: "head", label: "Head", x: 85, y: 20, r: 18 },
    { id: "throat", label: "Throat", x: 85, y: 48, r: 10 },
    { id: "chest", label: "Chest", x: 85, y: 75, r: 18 },
    { id: "solar_plexus", label: "Solar Plexus", x: 85, y: 105, r: 14 },
    { id: "abdomen", label: "Abdomen", x: 85, y: 130, r: 14 },
    { id: "pelvis", label: "Pelvis", x: 85, y: 158, r: 14 },
    { id: "left_shoulder", label: "Left Shoulder", x: 55, y: 65, r: 10 },
    { id: "right_shoulder", label: "Right Shoulder", x: 115, y: 65, r: 10 },
    { id: "left_arm", label: "Left Arm", x: 40, y: 100, r: 10 },
    { id: "right_arm", label: "Right Arm", x: 130, y: 100, r: 10 },
    { id: "left_hand", label: "Left Hand", x: 30, y: 135, r: 8 },
    { id: "right_hand", label: "Right Hand", x: 140, y: 135, r: 8 },
    { id: "left_thigh", label: "Left Thigh", x: 70, y: 190, r: 12 },
    { id: "right_thigh", label: "Right Thigh", x: 100, y: 190, r: 12 },
    { id: "left_knee", label: "Left Knee", x: 68, y: 220, r: 10 },
    { id: "right_knee", label: "Right Knee", x: 102, y: 220, r: 10 },
    { id: "left_foot", label: "Left Foot", x: 65, y: 265, r: 10 },
    { id: "right_foot", label: "Right Foot", x: 105, y: 265, r: 10 },
  ],
  back: [
    { id: "back_head", label: "Back of Head", x: 85, y: 20, r: 18 },
    { id: "neck", label: "Neck", x: 85, y: 48, r: 10 },
    { id: "upper_back", label: "Upper Back", x: 85, y: 75, r: 18 },
    { id: "mid_back", label: "Mid Back", x: 85, y: 105, r: 14 },
    { id: "lower_back", label: "Lower Back", x: 85, y: 130, r: 14 },
    { id: "glutes", label: "Glutes", x: 85, y: 158, r: 14 },
    { id: "back_left_shoulder", label: "Left Shoulder", x: 55, y: 65, r: 10 },
    { id: "back_right_shoulder", label: "Right Shoulder", x: 115, y: 65, r: 10 },
    { id: "back_left_arm", label: "Left Arm", x: 40, y: 100, r: 10 },
    { id: "back_right_arm", label: "Right Arm", x: 130, y: 100, r: 10 },
    { id: "left_hamstring", label: "Left Hamstring", x: 70, y: 190, r: 12 },
    { id: "right_hamstring", label: "Right Hamstring", x: 100, y: 190, r: 12 },
    { id: "left_calf", label: "Left Calf", x: 68, y: 230, r: 10 },
    { id: "right_calf", label: "Right Calf", x: 102, y: 230, r: 10 },
  ]
};

const SENSATIONS = [
  "Warmth", "Tingling", "Tension", "Openness",
  "Heaviness", "Lightness", "Buzzing", "Numbness",
  "Pressure", "Pulsing", "Relaxation", "Tightness",
  "Grounded", "Expansive"
];

function SomaticBodyMap({ value, onChange }) {
  const [view, setView] = useState("front");
  const [activeRegion, setActiveRegion] = useState(null);

  const sensations = value || [];

  const getRegionSensation = (regionId) =>
    sensations.find(s => s.region === regionId);

  const isActive = (regionId) => !!getRegionSensation(regionId);

  const handleRegionClick = (region) => {
    if (isActive(region.id)) {
      // already selected — deselect and remove
      onChange(sensations.filter(s => s.region !== region.id));
      setActiveRegion(null);
    } else if (activeRegion === region.id) {
      // clicked active but unselected region — just close panel
      setActiveRegion(null);
    } else {
      // new region — add and open panel
      setActiveRegion(region.id);
      onChange([...sensations, { region: region.id, label: region.label, sensation: "" }]);
    }
  };

  const handleSensationSelect = (regionId, sensation) => {
    onChange(sensations.map(s =>
      s.region === regionId ? { ...s, sensation } : s
    ));
  };

  const handleRemove = (regionId) => {
    onChange(sensations.filter(s => s.region !== regionId));
    if (activeRegion === regionId) setActiveRegion(null);
  };

  const currentRegions = BODY_REGIONS[view];
  const activeRegionData = currentRegions.find(r => r.id === activeRegion);

  return (
    <div className="SomaticBodyMap">
      <p style={{ fontSize: "13px", opacity: 0.6, marginBottom: "12px" }}>
        Tap a region to mark where you feel sensation. Tap again to deselect.
      </p>

      <div style={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
        {["front", "back"].map(v => (
          <span
            key={v}
            onClick={() => { setView(v); setActiveRegion(null); }}
            style={{
              cursor: "pointer",
              padding: "4px 14px",
              borderRadius: "20px",
              fontSize: "12px",
              border: view === v
                ? "1px solid rgba(125, 211, 232, 0.8)"
                : "1px solid rgba(255,255,255,0.2)",
              background: view === v
                ? "rgba(125, 211, 232, 0.15)"
                : "rgba(255,255,255,0.05)",
              color: view === v ? "#7dd3e8" : "inherit",
            }}
          >
            {v.charAt(0).toUpperCase() + v.slice(1)}
          </span>
        ))}
      </div>

      <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
        <svg width="170" height="290" style={{ flexShrink: 0 }}>
          <ellipse cx="85" cy="20" rx="18" ry="18" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" />
          <rect x="62" y="55" width="46" height="95" rx="8" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" />
          <rect x="32" y="58" width="30" height="80" rx="8" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" />
          <rect x="108" y="58" width="30" height="80" rx="8" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" />
          <rect x="63" y="148" width="22" height="90" rx="8" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" />
          <rect x="87" y="148" width="22" height="90" rx="8" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" />

          {currentRegions.map(region => (
            <circle
              key={region.id}
              cx={region.x}
              cy={region.y}
              r={region.r}
              fill={isActive(region.id)
                ? "rgba(125, 211, 232, 0.4)"
                : "rgba(255,255,255,0.03)"}
              stroke={isActive(region.id)
                ? "rgba(125, 211, 232, 0.9)"
                : activeRegion === region.id
                  ? "rgba(255,255,255,0.6)"
                  : "rgba(255,255,255,0.15)"}
              strokeWidth="1.5"
              style={{ cursor: "pointer" }}
              onClick={() => handleRegionClick(region)}
            />
          ))}
        </svg>

        <div style={{ flex: 1, minWidth: "160px" }}>
          {activeRegionData && isActive(activeRegion) && (
            <div style={{ marginBottom: "16px" }}>
              <p style={{ fontSize: "13px", fontWeight: "500", marginBottom: "8px" }}>
                {activeRegionData.label}
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {SENSATIONS.map(s => {
                  const current = getRegionSensation(activeRegion);
                  const isSelected = current && current.sensation === s;
                  return (
                    <span
                      key={s}
                      onClick={() => handleSensationSelect(activeRegion, s)}
                      style={{
                        cursor: "pointer",
                        padding: "4px 10px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        border: isSelected
                          ? "1px solid rgba(125, 211, 232, 0.8)"
                          : "1px solid rgba(255,255,255,0.15)",
                        background: isSelected
                          ? "rgba(125, 211, 232, 0.15)"
                          : "rgba(255,255,255,0.03)",
                        color: isSelected ? "#7dd3e8" : "inherit",
                      }}
                    >
                      {s}
                    </span>
                  );
                })}
              </div>
            </div>
          )}

          {sensations.length > 0 && (
            <div>
              <p style={{ fontSize: "12px", opacity: 0.5, marginBottom: "8px" }}>
                Marked regions:
              </p>
              {sensations.map(s => (
                <div key={s.region} style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "12px",
                  marginBottom: "6px",
                  padding: "4px 8px",
                  background: "rgba(255,255,255,0.05)",
                  borderRadius: "6px"
                }}>
                  <span>
                    {s.label}
                    {s.sensation && (
                      <span style={{ opacity: 0.6, marginLeft: "6px" }}>
                        — {s.sensation}
                      </span>
                    )}
                  </span>
                  <span
                    onClick={() => handleRemove(s.region)}
                    style={{ cursor: "pointer", opacity: 0.5, marginLeft: "8px", color: "#ffaa33" }}
                  >
                    ✕
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SomaticBodyMap;
*/

import { useState } from "react";

const BODY_REGIONS = {
  front: [
    { id: "head", label: "Head", x: 85, y: 20, r: 18 },
    { id: "throat", label: "Throat", x: 85, y: 48, r: 10 },
    { id: "chest", label: "Chest", x: 85, y: 75, r: 18 },
    { id: "solar_plexus", label: "Solar Plexus", x: 85, y: 105, r: 14 },
    { id: "abdomen", label: "Abdomen", x: 85, y: 130, r: 14 },
    { id: "pelvis", label: "Pelvis", x: 85, y: 158, r: 14 },
    { id: "left_shoulder", label: "Left Shoulder", x: 55, y: 65, r: 10 },
    { id: "right_shoulder", label: "Right Shoulder", x: 115, y: 65, r: 10 },
    { id: "left_arm", label: "Left Arm", x: 40, y: 100, r: 10 },
    { id: "right_arm", label: "Right Arm", x: 130, y: 100, r: 10 },
    { id: "left_hand", label: "Left Hand", x: 30, y: 135, r: 8 },
    { id: "right_hand", label: "Right Hand", x: 140, y: 135, r: 8 },
    { id: "left_thigh", label: "Left Thigh", x: 70, y: 190, r: 12 },
    { id: "right_thigh", label: "Right Thigh", x: 100, y: 190, r: 12 },
    { id: "left_knee", label: "Left Knee", x: 68, y: 220, r: 10 },
    { id: "right_knee", label: "Right Knee", x: 102, y: 220, r: 10 },
    { id: "left_foot", label: "Left Foot", x: 65, y: 265, r: 10 },
    { id: "right_foot", label: "Right Foot", x: 105, y: 265, r: 10 },
  ],
  back: [
    { id: "back_head", label: "Back of Head", x: 85, y: 20, r: 18 },
    { id: "neck", label: "Neck", x: 85, y: 48, r: 10 },
    { id: "upper_back", label: "Upper Back", x: 85, y: 75, r: 18 },
    { id: "mid_back", label: "Mid Back", x: 85, y: 105, r: 14 },
    { id: "lower_back", label: "Lower Back", x: 85, y: 130, r: 14 },
    { id: "glutes", label: "Glutes", x: 85, y: 158, r: 14 },
    { id: "back_left_shoulder", label: "Left Shoulder", x: 55, y: 65, r: 10 },
    { id: "back_right_shoulder", label: "Right Shoulder", x: 115, y: 65, r: 10 },
    { id: "back_left_arm", label: "Left Arm", x: 40, y: 100, r: 10 },
    { id: "back_right_arm", label: "Right Arm", x: 130, y: 100, r: 10 },
    { id: "left_hamstring", label: "Left Hamstring", x: 70, y: 190, r: 12 },
    { id: "right_hamstring", label: "Right Hamstring", x: 100, y: 190, r: 12 },
    { id: "left_calf", label: "Left Calf", x: 68, y: 230, r: 10 },
    { id: "right_calf", label: "Right Calf", x: 102, y: 230, r: 10 },
  ]
};

const BASE_SENSATIONS = [
  "Warmth", "Tingling", "Tension", "Openness",
  "Heaviness", "Lightness", "Buzzing", "Numbness",
  "Pressure", "Pulsing", "Relaxation", "Tightness",
  "Grounded", "Expansive"
];

const MUSHROOM_SENSATIONS = [
  "Vibration", "Waves", "Energy Flow", "Dissolving",
  "Merging", "Flowing", "Radiant", "Contracting",
  "Rushing", "Still", "Rooted", "Raw", "Electric"
];

function SomaticBodyMap({ value, onChange, medicine_type }) {
  const [view, setView] = useState("front");
  const [activeRegion, setActiveRegion] = useState(null);
  const isMushroom = medicine_type === "mushroom";
  const SENSATIONS = isMushroom
    ? [...BASE_SENSATIONS, ...MUSHROOM_SENSATIONS]
    : BASE_SENSATIONS;

  const sensations = value || [];

  const getRegionSensation = (regionId) =>
    sensations.find(s => s.region === regionId);

  const isActive = (regionId) => !!getRegionSensation(regionId);

  const handleRegionClick = (region) => {
    if (isActive(region.id)) {
      onChange(sensations.filter(s => s.region !== region.id));
      setActiveRegion(null);
    } else if (activeRegion === region.id) {
      setActiveRegion(null);
    } else {
      setActiveRegion(region.id);
      onChange([...sensations, { region: region.id, label: region.label, sensation: "" }]);
    }
  };

  const handleSensationSelect = (regionId, sensation) => {
    onChange(sensations.map(s =>
      s.region === regionId ? { ...s, sensation } : s
    ));
  };

  const handleRemove = (regionId) => {
    onChange(sensations.filter(s => s.region !== regionId));
    if (activeRegion === regionId) setActiveRegion(null);
  };

  const currentRegions = BODY_REGIONS[view];
  const activeRegionData = currentRegions.find(r => r.id === activeRegion);

  return (
    <div className="SomaticBodyMap">
      <p style={{ fontSize: "13px", opacity: 0.6, marginBottom: "12px" }}>
        Tap a region to mark where you feel sensation. Tap again to deselect.
      </p>

      <div style={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
        {["front", "back"].map(v => (
          <span
            key={v}
            onClick={() => { setView(v); setActiveRegion(null); }}
            style={{
              cursor: "pointer",
              padding: "4px 14px",
              borderRadius: "20px",
              fontSize: "12px",
              border: view === v
                ? "1px solid rgba(125, 211, 232, 0.8)"
                : "1px solid rgba(255,255,255,0.2)",
              background: view === v
                ? "rgba(125, 211, 232, 0.15)"
                : "rgba(255,255,255,0.05)",
              color: view === v ? "#7dd3e8" : "inherit",
            }}
          >
            {v.charAt(0).toUpperCase() + v.slice(1)}
          </span>
        ))}
      </div>

      <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
        <svg width="170" height="290" style={{ flexShrink: 0 }}>
          <ellipse cx="85" cy="20" rx="18" ry="18" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" />
          <rect x="62" y="55" width="46" height="95" rx="8" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" />
          <rect x="32" y="58" width="30" height="80" rx="8" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" />
          <rect x="108" y="58" width="30" height="80" rx="8" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" />
          <rect x="63" y="148" width="22" height="90" rx="8" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" />
          <rect x="87" y="148" width="22" height="90" rx="8" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1.5" />

          {currentRegions.map(region => (
            <circle
              key={region.id}
              cx={region.x}
              cy={region.y}
              r={region.r}
              fill={isActive(region.id)
                ? "rgba(125, 211, 232, 0.4)"
                : "rgba(255,255,255,0.03)"}
              stroke={isActive(region.id)
                ? "rgba(125, 211, 232, 0.9)"
                : activeRegion === region.id
                  ? "rgba(255,255,255,0.6)"
                  : "rgba(255,255,255,0.15)"}
              strokeWidth="1.5"
              style={{ cursor: "pointer" }}
              onClick={() => handleRegionClick(region)}
            />
          ))}
        </svg>

        <div style={{ flex: 1, minWidth: "160px" }}>
          {activeRegionData && isActive(activeRegion) && (
            <div style={{ marginBottom: "16px" }}>
              <p style={{ fontSize: "13px", fontWeight: "500", marginBottom: "8px" }}>
                {activeRegionData.label}
              </p>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {SENSATIONS.map(s => {
                  const current = getRegionSensation(activeRegion);
                  const isSelected = current && current.sensation === s;
                  const isMushroomSpecific = MUSHROOM_SENSATIONS.includes(s);
                  return (
                    <span
                      key={s}
                      onClick={() => handleSensationSelect(activeRegion, s)}
                      style={{
                        cursor: "pointer",
                        padding: "4px 10px",
                        borderRadius: "12px",
                        fontSize: "12px",
                        border: isSelected
                          ? "1px solid rgba(125, 211, 232, 0.8)"
                          : isMushroomSpecific
                            ? "1px solid rgba(180, 125, 232, 0.3)"
                            : "1px solid rgba(255,255,255,0.15)",
                        background: isSelected
                          ? "rgba(125, 211, 232, 0.15)"
                          : isMushroomSpecific
                            ? "rgba(180, 125, 232, 0.07)"
                            : "rgba(255,255,255,0.03)",
                        color: isSelected ? "#7dd3e8" : isMushroomSpecific ? "#c89ef0" : "inherit",
                      }}
                    >
                      {s}
                    </span>
                  );
                })}
              </div>
            </div>
          )}

          {sensations.length > 0 && (
            <div>
              <p style={{ fontSize: "12px", opacity: 0.5, marginBottom: "8px" }}>
                Marked regions:
              </p>
              {sensations.map(s => (
                <div key={s.region} style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "12px",
                  marginBottom: "6px",
                  padding: "4px 8px",
                  background: "rgba(255,255,255,0.05)",
                  borderRadius: "6px"
                }}>
                  <span>
                    {s.label}
                    {s.sensation && (
                      <span style={{ opacity: 0.6, marginLeft: "6px" }}>— {s.sensation}</span>
                    )}
                  </span>
                  <span
                    onClick={() => handleRemove(s.region)}
                    style={{ cursor: "pointer", opacity: 0.5, marginLeft: "8px", color: "#ffaa33" }}
                  >
                    ✕
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SomaticBodyMap;

